import { Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { PriceProviderService } from 'src/app/services/price-provider.service';
import calculateBaseOdds from 'src/app/utils/pity-odds-calculator';

Chart.register(...registerables);

@Component({
  selector: 'jewels-root',
  templateUrl: './jewels.component.html',
  styleUrls: ['../../shared-scss/default.scss'],
  standalone: false,
})
export class JewelsComponent implements OnInit {
  constructor(
    private readonly gaService: GoogleAnalyticsService,
    readonly priceProvider: PriceProviderService
  ) {}

  ngOnInit(): void {
    this.SimulateUpgrading(false);
  }
  title = 'flyff-upgrade-calculator';

  simulationCount = 10000;

  aProsUsed: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  pd8Used: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  customUpgradeBonus = 0;
  getModifier() {
    let bonus = this.customUpgradeBonus;
    if (this.priceProvider.isFwc) {
      bonus += 100;
    }
    return 1 + bonus / 100;
  }
  isPd10 = false;
  isUpgradingEvent = false;
  currentAttemptsIn = 0;
  currentUpgrade = 7;
  targetUpgrade = 20;

  baseOdds = [
    90, 85, 63, 45, 33, 26, 21, 17, 14, 11, 9, 8, 6, 5, 4, 3, 2, 1, 0.7, 0.1,
  ];
  basePd10Odds = [
    100, 100, 69.3, 49.5, 36.3, 28.6, 23, 19, 15, 12, 10.8, 9.6, 7.2, 6, 4.8,
    3.6, 2.4, 1.2, 0.84, 0.12,
  ];
  baseEventOdds = [
    95, 90, 66.1, 47.2, 34.6, 27.3, 22, 17.9, 14.7, 11.5, 9.9, 8.8, 6.6, 5.5,
    4.4, 3.3, 2.2, 1.1, 0.77, 0.11,
  ];
  baseEventPd10Odds = [
    100, 100, 72.7, 52, 38.1, 30.9, 24.2, 19.6, 16.1, 12.7, 11.9, 10.5, 7.9,
    6.6, 5.2, 4, 2.6, 1.3, 0.92, 0.138,
  ];

  odds = this.baseOdds.map((x) => x * this.getModifier());
  pd10Odds = this.basePd10Odds.map((x) => x * this.getModifier());
  eventOdds = this.baseEventOdds.map((x) => x * this.getModifier());
  eventPd10Odds = this.baseEventPd10Odds.map((x) => x * this.getModifier());

  pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsPd10 = this.basePd10Odds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsEvent = this.baseEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsEventPd10 = this.baseEventPd10Odds.map((x) => calculateBaseOdds(x * this.getModifier()));

  myChart: Chart | undefined = undefined;

  GenerateChart() {
    if (this.myChart) {
      this.myChart.destroy();
    }

    const chartData: any = {
      labels: [
        '+0 > +1',
        '+1 > +2',
        '+2 > +3',
        '+3 > +4',
        '+4 > +5',
        '+5 > +6',
        '+6 > +7',
        '+7 > +8',
        '+8 > +9',
        '+9 > +10',
        '+10 > +11',
        '+11 > +12',
        '+12 > +13',
        '+13 > +14',
        '+14 > +15',
        '+15 > +16',
        '+16 > +17',
        '+17 > +18',
        '+18 > +19',
        '+19 > +20',
      ],
      datasets: [
        {
          label: "aPro's",
          data: this.aProsUsed.map((x) => x / this.simulationCount),
          borderWidth: 1,
        },
      ],
    };

    const config: any = {
      type: 'bar',
      data: chartData,
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    };

    const chartElem = <HTMLCanvasElement>(
      document.getElementById(`upgrade-data-chart`)
    );

    this.myChart = new Chart(chartElem, config);
  }

  SimulateUpgrading(isUserInput = true) {
    if (!this.verifyInput()) {
      return;
    }

    if (isUserInput) {
      this.gaService.event(
        'simulate_jewelry_upgrade',
        'simulate',
        'Simulate jewelry upgrade',
        this.simulationCount,
        true
      );
    }

    // Reset starter values
    this.aProsUsed = [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ];
    this.pd8Used = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // Calculate modified odds with upgrade bonus
    this.odds = this.baseOdds.map((x) => x * this.getModifier());
    this.pd10Odds = this.basePd10Odds.map((x) => x * this.getModifier());
    this.eventOdds = this.baseEventOdds.map((x) => x * this.getModifier());
    this.eventPd10Odds = this.baseEventPd10Odds.map((x) => x * this.getModifier());

    this.pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsPd10 = this.basePd10Odds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEvent = this.baseEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEventPd10 = this.baseEventPd10Odds.map((x) => calculateBaseOdds(x * this.getModifier()));

    // Start upgrading
    for (let i = 0; i < this.simulationCount; i++) {
      let currentUpgrade = this.currentUpgrade;

      while (currentUpgrade < this.targetUpgrade) {
        let failedTries = 0;
        if (currentUpgrade === this.currentUpgrade) {
          failedTries = this.currentAttemptsIn;
        }
        let isSuccessful = false;
        while (!isSuccessful) {
          isSuccessful = this.SimulateSingleUpgrade(
            currentUpgrade,
            failedTries
          );
          if (!isSuccessful) {
            failedTries++;
          }
        }
        currentUpgrade++;
      }
    }

    this.GenerateChart();
  }

  verifyInput() {
    // clear all red inputs
    let isValid = true;
    if (this.currentUpgrade < 0 || this.currentUpgrade > 19) {
      // make input red
      isValid = false;
    }
    if (this.targetUpgrade < 1 || this.targetUpgrade > 20) {
      // make input red
      isValid = false;
    }
    if (this.currentUpgrade >= this.targetUpgrade) {
      // make input red
      isValid = false;
    }
    if (this.currentAttemptsIn < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.aProPrice < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.pd8Price < 0) {
      // make input red
      isValid = false;
    }
    return isValid;
  }

  addUpgradeTry(currentUpgrade: number) {
    this.aProsUsed[currentUpgrade]++;
    this.pd8Used[currentUpgrade]++;
  }

  SimulateSingleUpgrade(currentUpgrade: number, failedTries: number): boolean {
    this.addUpgradeTry(currentUpgrade);
    const random = Math.random() * 100;
    let odds = this.GetUpgradeOdds()[currentUpgrade] * (failedTries + 1);

    if (random < odds) {
      return true;
    }
    return false;
  }

  GetAprosUsed(): number {
    return this.aProsUsed.reduce((a, b) => a + b, 0);
  }

  GetPd8sUsed(): number {
    return this.pd8Used.reduce((a, b) => a + b, 0);
  }

  GetTotalPenyaCost(): number {
    const totalAproCost = this.GetAprosUsed() * this.priceProvider.aProPrice;
    const totalDiceCost = this.GetPd8sUsed() * this.priceProvider.pd8Price;
    return totalAproCost + totalDiceCost;
  }

  GetUpgradeOdds(): number[] {
    const isPity = true;
    type OddsKey = 'default' | 'upgradeEvent' | 'pd10' | 'upgradeEventPd10';

    const baseOdds: Record<OddsKey, number[]> = {
      default: this.odds,
      upgradeEvent: this.eventOdds,
      pd10: this.pd10Odds,
      upgradeEventPd10: this.eventPd10Odds,
    };

    const pityOdds: Record<OddsKey, number[]> = {
      default: this.pityOdds,
      upgradeEvent: this.pityOddsEvent,
      pd10: this.pityOddsPd10,
      upgradeEventPd10: this.pityOddsEventPd10,
    };

    let key: OddsKey = 'default';
    if (this.isPd10 && this.isUpgradingEvent) key = 'upgradeEventPd10';
    else if (this.isUpgradingEvent) key = 'upgradeEvent';
    else if (this.isPd10) key = 'pd10';

    let odds;

    if (isPity) {
      odds = pityOdds[key];
    } else {
      odds = baseOdds[key];
    }
    return odds;
  }
}
